import * as React from 'react';
import Formsy from 'formsy-react';
import cx from 'classnames';
import {Button} from 'components/Button';
import {FormsyInput, Input} from 'components/Input';
import ReCAPTCHA from 'react-google-recaptcha';
import style from './InitialProject.css';

import {isMobile} from '_utils';

export class Form extends React.Component {
    constructor(props) {
        super(props);
        this.disableButton = this.disableButton.bind(this);
        this.enableButton = this.enableButton.bind(this);

        this.state = {
            globalError: null,
            canSubmit: false,
            reCaptcha: null,
            others: {}
        };
    }

    onChange = (value) => {
        this.setState({
            reCaptcha: value
        });
    };

    handleChangeForm = () => {
        const formData = this.form.getModel();
        const others = {};

        for (let key in formData) {
            if (formData[key] === 'Other') {
                others[key] = true;
            }
        }

        if (JSON.stringify(others) !== JSON.stringify(this.state.others)) {
            this.setState({
                others
            });
        }

        if (this.state.globalError) {
            this.setState(() => ({
                globalError: null
            }));
        }
    };

    disableButton() {
        this.setState({canSubmit: false});
    }

    enableButton() {
        this.setState({canSubmit: true});
    }

    submit = (model, reset, invalidate) => {
        fetch('/api/send_project_form', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'g-recaptcha-response': this.state.reCaptcha,
                project_form: model
            })
        }).then(response => response.status === 204 ? '' : response.json().then(data => {
            if (response.ok) {
                return data;
            }
            return Promise.reject({status: response.status, ...data});
        })).then(() => {
            reset();
            this.props.onSubmit();
        }).catch(error => {
            if (error.errors) {
                return this.setState({
                    globalError: 'Invalidate form'
                });
            }

            if (error.status === 500) {
                return this.setState({
                    globalError: 'Internal server error!!!'
                });
            }

            this.setState({
                globalError: 'Something wrong!!!'
            });
        });
    };

    isValidGroup = (name) => (values, value) => {
        if (this.state.others[name]) {
            return true
        }

        return value && value.trim() ? true : 'Field is required';
    };

    isValidOther = (name) => (values, value) => {
        if (this.state.others[name]) {
            return value && value.trim() ? true : 'Field is required';
        }

        return true;
    };

    render() {
        const {others} = this.state;
        return (
            <Formsy
                ref={c => this.form = c}
                className={style.form}
                onValidSubmit={this.submit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                onChange={this.handleChangeForm}
            >
                <div className={style.row}>
                    <label className={style.label} htmlFor="email">
                        Email&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        autoComplete="on"
                        name="email"
                        validations="isEmail"
                        validationErrors={{
                            isEmail: "This is not a valid email",
                            isDefaultRequiredValue: "Field is required"
                        }}
                        required
                    />
                </div>
                <div className={style.row}>
                    <label className={style.label} htmlFor="name">
                        Company/Project Name&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="name"
                        autoComplete="on"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>
                <div className={style.row}>
                    <label className={style.label} htmlFor="contact">
                        Lead Point of Contact (Name, position)&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="contact"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>
                
                <div className={style.row}>
                    <label className={style.label} htmlFor="statement">
                        Describe your project in a brief statement&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="statement"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>
                
                <div className={style.row}>
                    <label className={style.label} htmlFor="statement">
                        Describe the technology or infrastructure you intend to use&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="statement"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>

                <div className={style.row}>
                    <label className={style.label} htmlFor="statement">
                        What is the current stage & progress of your project&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="statement"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>

                <div className={style.row}>
                    <label className={style.label} htmlFor="team">
                        How large is your current team?&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="team"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>
                
                <div className={style.row}>
                    <label className={style.label} htmlFor="services">
                        What services are you looking for from BlockScience&nbsp;?&nbsp;<i className={style.star}>*</i>
                    </label>
                    <FormsyInput
                        name="services"
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Field is required'
                        }}
                    />
                </div>
                <ReCAPTCHA
                    size={isMobile ? 'compact' : 'normal'}
                    ref="recaptcha"
                    sitekey="6LfM4WkUAAAAAO3itAPhNubI9A9ujYrT7tpJGlwN"
                    onChange={this.onChange}
                />
                {this.state.globalError && <p className={style.globalError}>{this.state.globalError}</p> }
                <Button type="submit" className={style.submit}>
                    submit
                </Button>
            </Formsy>
        );
    }

}